import { useRef } from 'react';
import { useT } from '../i18n';
import { CameraIcon, ImageIcon } from './Icons';

/**
 * Two big buttons: «Камера» opens the back camera directly (capture=environment), «Галерея» the file picker
 * (photos already taken, PDF scans; several at once). The camera takes one shot per tap — tap again for the next. Photos are downscaled to ≤1600px JPEG later, right before upload
 * (lib/image.ts); HEIC goes as it is.
 */
export function PhotoCapture({ onPick, disabled, allowPdf = false }: { onPick: (files: File[]) => void; disabled?: boolean; allowPdf?: boolean }) {
  const t = useT();
  const cam = useRef<HTMLInputElement>(null);
  const pick = useRef<HTMLInputElement>(null);
  const take = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files ?? []);
    e.target.value = '';
    if (files.length) onPick(files);
  };
  return (
    <div className="grid grid-cols-2 gap-3">
      <button type="button" className="btn-primary min-h-big flex-col gap-1 rounded-2xl" disabled={disabled} onClick={() => cam.current?.click()}>
        <CameraIcon />
        <span>{t('photo.camera')}</span>
      </button>
      <button type="button" className="btn min-h-big flex-col gap-1 rounded-2xl" disabled={disabled} onClick={() => pick.current?.click()}>
        <ImageIcon />
        <span>{t('photo.gallery')}</span>
      </button>
      <input
        ref={cam}
        type="file"
        accept="image/*"
        capture="environment"
        className="hidden"
        data-testid="photo-camera"
        onChange={take}
      />
      <input
        ref={pick}
        type="file"
        accept={allowPdf ? 'image/*,application/pdf' : 'image/*'}
        multiple
        className="hidden"
        data-testid="photo-picker"
        onChange={take}
      />
    </div>
  );
}
